<div class="auth-container">
  <div class="row auth-main">
    <div class="col-xl-5 d-none d-xl-block px-0 left-col">
      <div class="image-wrapper"></div>
    </div>

    <div class="col-sm-7 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <h5 class="welcome-msg">CONFIRMACION DE CUENTA</h5>
          <p class="auth-signup-text text-muted">
            CREA UNA NUEVA CONTRASENA PARA ACTIVAR TU CUENTA. ASEGURATE DE RECORDARLA.
          </p>

          <form [formGroup]="authForm" class="validate-form">
            <div class="row">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>CORREO</mat-label>
                  <input
                    autocomplete="nope"
                    formControlName="email"
                    matInput
                    type="email"
                  />
                </mat-form-field>

                <div *ngIf="emailCtrl?.touched && emailCtrl?.hasError('required')" class="custom-error-below">
                  <small class="text-danger">EL CORREO ES REQUERIDO</small>
                </div>

                <div *ngIf="emailCtrl?.touched && emailCtrl?.hasError('email')" class="custom-error-below">
                  <small class="text-danger">EL CORREO NO ES VALIDO</small>
                </div>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>NUEVA CONTRASENA</mat-label>
                  <input
                    [type]="hide ? 'password' : 'text'"
                    autocomplete="nope"
                    formControlName="password"
                    matInput
                  />
                  <mat-icon
                    (click)="hide = !hide"
                    class="material-icons-outlined pwd-toggle p-3"
                    matSuffix
                  >
                    {{ hide ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </mat-form-field>

                <div *ngIf="password?.touched && password?.hasError('required')" class="custom-error-below">
                  <small class="text-danger">LA CONTRASENA ES REQUERIDA</small>
                </div>

                <div *ngIf="password?.touched && password?.hasError('pattern')" class="custom-error-below">
                  <small class="text-danger">
                    LA CONTRASENA DEBE TENER AL MENOS 12 CARACTERES, 1 SIMBOLO, 1 NUMERO, 1 MAYUSCULA Y 1 MINUSCULA.
                  </small>
                </div>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>CONFIRMA TU CONTRASENA</mat-label>
                  <input
                    [type]="chide ? 'password' : 'text'"
                    autocomplete="nope"
                    formControlName="confirmedPassword"
                    matInput
                  />
                  <mat-icon
                    (click)="chide = !chide"
                    class="material-icons-outlined pwd-toggle p-3"
                    matSuffix
                  >
                    {{ chide ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </mat-form-field>

                <div *ngIf="confirmedPassword?.touched && confirmedPassword?.hasError('required')" class="custom-error-below">
                  <small class="text-danger">LA CONFIRMACION DE LA CONTRASENA ES REQUERIDA</small>
                </div>

                <div *ngIf="confirmedPassword?.touched && confirmedPassword?.hasError('pattern')" class="custom-error-below">
                  <small class="text-danger">
                    LA CONTRASENA DEBE TENER AL MENOS 12 CARACTERES, 1 SIMBOLO, 1 NUMERO, 1 MAYUSCULA Y 1 MINUSCULA.
                  </small>
                </div>

                <div *ngIf="passwordsDoNotMatch" class="custom-error-below">
                  <small class="text-danger">LAS CONTRASENAS NO COINCIDEN</small>
                </div>
              </div>

            </div>

            <div class="container-auth-form-btn mt-4">
              <button
                (click)="resetPassword()"
                [disabled]="authForm.invalid || passwordsDoNotMatch || !encryptedToken"
                class="auth-form-btn"
                color="accent"
                mat-flat-button
                type="button"
              >
                CONFIRMAR CUENTA
              </button>
            </div>

            <div class="w-full p-t-20 text-center">
              <button
                mat-button
                color="primary"
                type="button"
                (click)="resendVerifyEmail()"
                [disabled]="emailCtrl?.invalid"
              >
                REENVIAR CORREO DE CONFIRMACION
              </button>
            </div>

            <div class="w-full p-t-15 text-center">
              <div>
                <a class="txt1" routerLink="/authentication/signin">
                  ACCEDER A LA PLATAFORMA
                </a>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
